let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1Jqoz")).then(() => parcelRequire('5u94T'));